//#region Imports & External Dependencies
import { action, computed, makeObservable, observable } from "mobx";
import { ViewModelBase } from "@shoothill/core";
import { APIClient, RelayCommand } from "Application";
import { IModel } from "@shoothill/core";
//#endregion

//ViewModelBaseExtended is an extension of ViewModelBase that adds a few extra properties and methods used across the application

//#region Class Definition
export class ViewModelBaseExtended<T extends IModel<T>> extends ViewModelBase<T> {
    //#endregion

    //#region Properties & State
    public apiClient = new APIClient();

    public _isBusy: boolean = false;
    public _render: boolean = false;
    public _isLoading: boolean = false;
    public _isProcessing: boolean = false;
    //#endregion

    //#region Constructor/Initialization
    constructor(model: T) {
        super(model);
        makeObservable(this, {
            _isBusy: observable,
            _render: observable,
            _isLoading: observable,
            _isProcessing: observable,
            isBusy: computed,
            render: computed,
            isLoading: computed,
            isProcessing: computed,
            setIsBusy: action,
            setRender: action,
            setIsLoading: action,
            setIsProcessing: action,
        });
    }
    //#endregion

    //#region Public Methods & Commands
    public setIsBusy = (value: boolean) => {
        this._isBusy = value;
    };
    public setRender = (value: boolean) => {
        this._render = value;
    };
    public setIsLoading = (value: boolean) => {
        this._isLoading = value;
    };

    public setIsProcessing = (value: boolean) => {
        this._isProcessing = value;
    };

    public resetErrorCommand = new RelayCommand(() => {
        this.apiClient.reset();
    });
    //#endregion

    //#region Computed Properties & Getters
    public get isBusy() {
        return this._isBusy;
    }

    public get render() {
        return this._render;
    }
    public get isLoading() {
        return this._isLoading;
    }

    public get isProcessing() {
        return this._isProcessing;
    }
    //#endregion
}
//#endregion
